import { ChatMainContainer } from '@features/chat/components/ChatMainContainer';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/chat')({ component: ChatMainContainer });
